var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app',{style:({
      'background-color':
        _vm.env.NODE_ENV !== 'production' ? 'rgb(245,222,179)' : '#fff',
    })},[_c('v-container',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }